import mountSettlementWidget from './src/mount';

window.mountSettlementWidget = mountSettlementWidget;
export { mountSettlementWidget };
